<template>
    <div>
        <ModalCommon :id="`configModalActionTitle-${config?.id ?? ''}`" :config="config" @save="handleSave()" @close="handleClose()">
            <!-- タイトル -->
            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" for="adsfasđs" style="min-width: 100px"
                    >{{ $t('landingPage.settingPrize.titlePrize') }} <span class="text-danger">*</span></label
                >
                <div class="col-sm-10">
                    <InputText
                        :model.sync="dataFormTitle.title"
                        :config.sync="configFormTitleLP.configFieldTitlePrize"
                        @blur="handleValidateField(configFormTitleLP.configFieldTitlePrize)"
                    />
                    <div class="mt-3">
                        <div class="form-group row">
                            <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.setSizeText') }}</label>
                            <div class="col-sm-3">
                                <div class="d-flex align-items-center" style="gap: 0.5rem">
                                    <InputText
                                        style="max-width: 120px"
                                        :model.sync="dataFormTitle.size_prize"
                                        :config.sync="configFormTitleLP.configFieldSizeTitle"
                                    />
                                    <span>px</span>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.colorText') }}</label>
                            <div class="col-sm-5">
                                <div class="d-flex" style="gap: 1rem">
                                    <InputText
                                        style="min-width: 100px"
                                        :model.sync="dataFormTitle.color_prize"
                                        :config="{
                                            type: 'color',
                                            classCustom: 'form-control-color',
                                            error: false
                                        }"
                                    />
                                    <InputText
                                        style="max-width: 100px"
                                        :model.sync="dataFormTitle.color_prize"
                                        :config="{
                                            error: false
                                        }"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.backgroundText') }}</label>
                            <div class="col-sm-5">
                                <div class="d-flex" style="gap: 1rem">
                                    <InputText
                                        style="min-width: 100px"
                                        :model.sync="dataFormTitle.background_prize"
                                        :config="{
                                            type: 'color',
                                            classCustom: 'form-control-color',
                                            error: false
                                        }"
                                    />
                                    <InputText
                                        style="max-width: 100px"
                                        :model.sync="dataFormTitle.background_prize"
                                        :config="{
                                            error: false
                                        }"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 画像 -->
            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" for="adsfasđs" style="min-width: 80px"
                    >{{ $t('landingPage.settingPrize.imagePrize') }} <span class="text-danger">*</span></label
                >
                <div class="col-sm-11">
                    <UploadImageCommon
                        :fileValues.sync="dataFormTitle.image"
                        @dataFile="handleFileBackgroundEditor"
                        :id="`ImgTitlePrize`"
                        :config="{
                            maxSize: 2048
                        }"
                    >
                        <template #warning>
                            <div style="font-size: 13px">
                                {{ $t('noteUploadMaxMB') }}
                            </div>
                        </template>
                    </UploadImageCommon>
                    <div v-if="isRequiredImage" class="invalid-feedback d-block">
                        {{
                            $t('validateField.requiredSelect', {
                                field: $t('landingPage.settingPrize.imagePrize')
                            })
                        }}
                    </div>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 80px">{{ $t('landingPage.backgroundText') }}</label>
                <div class="col-sm-5">
                    <div class="d-flex" style="gap: 1rem">
                        <InputText
                            style="min-width: 100px"
                            :model.sync="dataFormTitle.background_item"
                            :config="{
                                type: 'color',
                                classCustom: 'form-control-color',
                                error: false
                            }"
                        />
                        <InputText
                            style="max-width: 100px"
                            :model.sync="dataFormTitle.background_item"
                            :config="{
                                error: false
                            }"
                        />
                    </div>
                </div>
            </div>
            <!-- 詳細 -->
            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 80px">{{ $t('landingPage.settingPrize.detailPrize') }} </label>
                <div class="col-sm-11">
                    <Editor
                        v-if="isVisibleEditor"
                        :id="`configModalActionTitle-${config?.id ?? ''}`"
                        :model.sync="dataFormTitle.detail"
                        :modelEvents="`change keydown blur focus paste`"
                        :configInit="configEditor"
                        @init="onEditorInit"
                    />
                </div>
            </div>
            <!-- 当選人数 -->
            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 80px">{{ $t('landingPage.settingPrize.numberOfWinners') }} </label>
                <div class="col-sm-11">
                    <textarea row="3" class="form-control" v-model="dataFormTitle.number_of_winner"></textarea>
                </div>
            </div>
            <!-- ステータス -->
            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 80px">{{ $t('landingPage.settingPrize.status') }} </label>
                <div class="col-sm-11">
                    <div class="d-flex">
                        <div v-for="item in STATUS_TITLE_PRIZE" :key="item.id + 's'">
                            <InputRadio
                                class="mr-4"
                                :model.sync="dataFormTitle.status"
                                :name="`statusTitlePrize`"
                                :id="`statusTitlePrize-${item.id}`"
                                :value="item.value"
                                :label="item.name"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </ModalCommon>
    </div>
</template>

<script>
import { InputText, InputRadio } from '@/components/Input';
import { configFormTitleLP, STATUS_TITLE_PRIZE } from './constants';
import { validateField, validateAllField } from '@/utils/validate';
import { IMAGE_EXTENSIONS } from '@/utils/format';

import ModalCommon from '@/components/Modal/main.vue';
import UploadImageCommon from '@/components/Uploads/Image/main.vue';
import Editor from '@/components/Editor/main.vue';

export default {
    name: 'ModalEditPrize',
    components: {
        InputText,
        ModalCommon,
        UploadImageCommon,
        Editor,
        InputRadio
    },
    props: {
        config: {
            type: Object,
            required: true,
            default: () => null
        },
        dataTitle: {
            type: Object,
            required: true,
            default: () => null
        }
    },
    data() {
        return {
            STATUS_TITLE_PRIZE: STATUS_TITLE_PRIZE,
            configFormTitleLP: configFormTitleLP,
            dataFormTitle: this.dataTitle,
            arrExtension: IMAGE_EXTENSIONS,
            dataFormTitleCopy: JSON.parse(JSON.stringify(this.dataTitle)),
            isVisibleEditor: false,
            isRequiredImage: false,
            objEditor: null,
            configEditor: {
                height: 600
            }
        };
    },
    methods: {
        handleValidateField(configField) {
            validateField(configField);
        },

        handleSave() {
            let checkValidate = validateAllField(configFormTitleLP);
            this.isRequiredImage = !this.dataFormTitle.image;
            if (!checkValidate || this.isRequiredImage) return;
            if (this.dataFormTitle?.id || (this.dataFormTitle?.make_id && this.dataFormTitle?.typeAction === 'Edit')) {
                this.$emit('updateData', this.dataFormTitle);
            } else {
                this.dataFormTitle.typeAction = 'Edit';
                this.$emit('addData', this.dataFormTitle);
            }
            this.config.model = false;
        },

        handleClose() {
            let { configFieldTitlePrize } = this.configFormTitleLP;
            configFieldTitlePrize.error = false;
            this.dataFormTitle = this.dataFormTitleCopy;
            this.$emit('updateData', this.dataFormTitle);
            this.config.model = false;
        },

        renderListLv1(idOrigin, checkIdLv1) {
            return {
                check: idOrigin.id === checkIdLv1,
                itemLv1: idOrigin.data
            };
        },

        handleFileBackgroundEditor() {
            this.isRequiredImage = false;
        },

        onEditorInit(editor) {
            this.objEditor = editor;
        }
    },
    watch: {
        'config.model': {
            handler: function (newShow) {
                if (newShow) {
                    this.dataFormTitleCopy = JSON.parse(JSON.stringify(this.dataTitle));
                    this.isLoading = true;
                    setTimeout(() => {
                        this.isVisibleEditor = true;
                        this.isLoading = false;
                    }, 200);
                } else {
                    this.isVisibleEditor = false;
                }
            },
            immediate: true,
            deep: true
        }
    }
};
</script>

<style lang="scss" scoped></style>
